import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../infrastructure/api/client";
import { ApiError } from "@tabipla/shared";
import { balanceKeys } from "./queryKeys";

interface GroupBalance {
  groupId: string;
  groupName: string;
  balance: number;
  sessionCount: number;
}

interface BalanceSummary {
  totalReceivable: number;
  totalPayable: number;
  netBalance: number;
  groups: GroupBalance[];
}

export function useTotalBalance() {
  return useQuery({
    queryKey: balanceKeys.summary,
    queryFn: async () => {
      const response = await apiClient.get<BalanceSummary>("/api/me/balance-summary");
      if (!response.success) {
        throw ApiError.fromResponse(response.error, "Failed to fetch balance summary");
      }
      return response.data;
    },
  });
}
